import { render } from "./rankCompressForm.vue?vue&type=template&id=1c5f1f86"
import script from "./rankCompressForm.vue?vue&type=script&lang=js"
export * from "./rankCompressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__